// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ce7ad4f","453":"dc892591","667":"d1a4fc11"}[chunkId] + ".chunk.js";
};